// extracted by mini-css-extract-plugin
export default {"form-check":"BankDetailsAccordion_form-check__pUte8"};